import { post, get ,postQuery,getQuery} from "./service";
import { workOrderApi, uploadUrl, erpDataApiDic, erpWebApiDic } from "./api";

import {postNewStore,getNewStore,postQueryNewStore} from "./serviceNewStore"

// login
export const postLogin = async(params) => {
    return await post(workOrderApi.postLogin, params);
};

// 工单 列表、详情
export const getOrderList = (params, type) => {
    if (type) {
        return get(workOrderApi.getOrderList + "/" + params);
    } else {
        return get(workOrderApi.getOrderList, params);
    }
};
// 创建工单
export const createWorkOrder = params =>
    post(workOrderApi.getOrderList, params);

// 工单状态
export const getOrderState = params => get(workOrderApi.getOrderState, params);

// 工单类型分类
export const getOrderTypeCategories = params =>
    get(workOrderApi.getOrderTypeCategories, params);

// 操作人相关
export const getOrderAction = params =>
    get(workOrderApi.getOrderAction, params);

// 上传
export const uploadFile = file => post(uploadUrl, file);

export const erpDataApi = {

    getAuditSetList: params => get(erpDataApiDic.getAuditSetList, params),
    addAuditSet: params => post(erpDataApiDic.addAuditSet, params),
    updateAuditSet: params => post(erpDataApiDic.updateAuditSet, params),
    deleteAuditSet: params => post(erpDataApiDic.deleteAuditSet, params),
    deleteAuditSetProcess: params => post(erpDataApiDic.deleteAuditSetProcess, params),

    getVillageDetail: params => get(erpDataApiDic.getVillageDetail, params),
    updateVillage: params => get(erpDataApiDic.updateVillage, params),
    getDepartmentDetail: params => get(erpDataApiDic.getDepartmentDetail, params),
    updateDepartment: params => get(erpDataApiDic.updateDepartment, params),
    addDepartment: params => get(erpDataApiDic.addDepartment, params),
    deleteDepartment: params => get(erpDataApiDic.deleteDepartment, params),
    getDepartmentAndUserList: params => get(erpDataApiDic.getDepartmentAndUserList, params),

    getPositionByDepartmentId: params => get(erpDataApiDic.getPositionByDepartmentId, params),
    getUserAccountListByIdpaging: params => get(erpDataApiDic.getUserAccountListByIdpaging, params),

    getUserBankAccountListByUserId: params => get(erpDataApiDic.getUserBankAccountListByUserId, params),
    userBankAccountAdd: params => get(erpDataApiDic.userBankAccountAdd, params),
    userBankAccountDelete: params => get(erpDataApiDic.userBankAccountDelete, params),

    deleteUser: params => get(erpDataApiDic.deleteUser, params),
    addUser: params => get(erpDataApiDic.addUser, params),
    UserUpdate: params => get(erpDataApiDic.UserUpdate, params),

    getDepartment: params => get(erpDataApiDic.getDepartments, params),
    getRoles: params => get(erpDataApiDic.getRoles, params),
    deleteRole: params => get(erpDataApiDic.deleteRole, params),
    getAllApplications: params => get(erpDataApiDic.getAllApplications, params),
    roleAdd: params => get(erpDataApiDic.roleAdd, params),
    roleUpdate: params => get(erpDataApiDic.roleUpdate, params),
    getRoleDetailById: params => get(erpDataApiDic.getRoleDetailById, params),
    getRoleApplications: params => get(erpDataApiDic.getRoleApplications, params),
    getRoleApplicationsList: params => get(erpDataApiDic.getRoleApplicationsList, params),
    roleApplicationAdd: params => post(erpDataApiDic.roleApplicationAdd, params),

    getRoleListNothing: params => post(erpDataApiDic.getRoleListNothing, params),
    getRoleUserListByRoleId: params => post(erpDataApiDic.getRoleUserListByRoleId, params),
    addRoleUser: params => post(erpDataApiDic.addRoleUser, params),
    deleteRoleUser: params => post(erpDataApiDic.deleteRoleUser, params),

    // {role_id:"", role_application_jsonText:"[{'application_id':'应用id','name':'应用名称','parent_id':'应用父id'}]"}
    roleApplicationUpdate: params => post(erpDataApiDic.roleApplicationUpdate, params),
    getAllTasks: params => get(erpDataApiDic.getAllTasks, params),
    getRoleTasks: params => get(erpDataApiDic.getRoleTasks, params),

    // {role_id:"", role_Task_jsonText:"[{'id':'应用id','title':'应用名称','children':[]}]"}
    addRoleTask: params => post(erpDataApiDic.addRoleTask, params),

    // {role_id:"", role_application_jsonText: "[{'Warehouse_id':'仓库id','Reservoir_id':'库区id','Storehouse_id':'库位id'}]"}
    saveRoleApplicationAddOnWarehouse: params => post(erpDataApiDic.saveRoleApplicationAddOnWarehouse, params),
    //获取所有仓库信息
    getAllWarehouse: params => get(erpDataApiDic.getAllWarehouse, params),
    //获取角色仓库信息
    getRoleWarehouse: params => get(erpDataApiDic.getRoleWarehouse, params),

    //获取全部数据字典列表
    getAllDictionary: params => get(erpDataApiDic.getAllDictionary, params),
    getDictionaryById: params => get(erpDataApiDic.getDictionaryById, params),
    addDictionary: params => get(erpDataApiDic.addDictionary, params),
    updateDictionary: params => get(erpDataApiDic.updateDictionary, params),
    deleteDictionary: params => get(erpDataApiDic.deleteDictionary, params),

    getDictionaryAreaList: params => get(erpDataApiDic.getDictionaryAreaList, params),
    getProductSpecs: params => get(erpDataApiDic.getProductSpecs, params),
    getProductOrigins: params => get(erpDataApiDic.getProductOrigins, params),
    getProductWarehouses: params => get(erpDataApiDic.getProductWarehouses, params),

    //单位
    getUnits: params => get(erpDataApiDic.getUnits, params),
    addUnit: params => get(erpDataApiDic.addUnit, params),
    updateUnit: params => get(erpDataApiDic.updateUnit, params),
    deleteUnit: params => get(erpDataApiDic.deleteUnit, params),

    getSNs: params => get(erpDataApiDic.getSNs, params),
    updateSN: params => get(erpDataApiDic.updateSN, params),
    getNumberRule: params => post(erpDataApiDic.getNumberRule, params),
    // GetCode: params => post(erpDataApiDic.GetCode, params), // 获取物料编码

    getProductBrands: params => get(erpDataApiDic.getProductBrands, params),
    addProductBrand: params => get(erpDataApiDic.addProductBrand, params),
    updateProductBrand: params => get(erpDataApiDic.updateProductBrand, params),
    deleteProductBrand: params => get(erpDataApiDic.deleteProductBrand, params),
    uploadProductBrandExcel: params => post(erpDataApiDic.uploadProductBrandExcel, params),
    uploadProductListExcelJson: params => post(erpDataApiDic.uploadProductListExcelJson, params),
    uploadSupplierListExcelJson: params => post(erpDataApiDic.uploadSupplierListExcelJson, params),
    uploadCustomerListExcelJson: params => post(erpDataApiDic.uploadCustomerListExcelJson, params),
    downloadProductBrandExcelTemplate: () => location.href = erpDataApiDic.downloadProductBrandExcelTemplate,
    downloadProductListExcelTemplate: () => location.href = erpDataApiDic.downloadProductListExcelTemplate,
    downloadSupplierListExcelTemplate: () => location.href = erpDataApiDic.downloadSupplierListExcelTemplate,
    downloadCustomerListExcelTemplate: () => location.href = erpDataApiDic.downloadCustomerListExcelTemplate,
    downloadUserExcelTemplate: () => location.href = erpDataApiDic.downloadUserExcelTemplate,
    downloadOrderListExcelTemplate: () => location.href = erpDataApiDic.downloadOrderListExcelTemplate,
    downloadStoreProductExcelTemplate: ()=> location.href = erpDataApiDic.downloadStoreProductExcelTemplate,

    getProductQRCode: params => get(erpDataApiDic.getProductQRCode, params),
    getSerialList: params => get(erpDataApiDic.getSerialList, params),
    updateCode: params => get(erpDataApiDic.updateCode, params),
    deleteCode: params => get(erpDataApiDic.deleteCode, params),
    addSerialNumer: params => get(erpDataApiDic.addSerialNumer, params),

    addCardList: params => post(erpDataApiDic.addCardList, params),

    CustomerBankAccountUpdate: params => post(erpDataApiDic.CustomerBankAccountUpdate, params),

    

    getProductCategories: params => get(erpDataApiDic.getProductCategories, params),
    getProducts: params => get(erpDataApiDic.getProducts, params),
    getProductById: params => get(erpDataApiDic.getProductById, params),
    addProduct: params => get(erpDataApiDic.addProduct, params),
    updateProduct: params => get(erpDataApiDic.updateProduct, params),
    deleteProduct: params => get(erpDataApiDic.deleteProduct, params),

    getSupplierTypes: params => post(erpDataApiDic.getSupplierTypes, params),
    getSuppliers: params => post(erpDataApiDic.getSuppliers, params),
    deleteSupplier: params => post(erpDataApiDic.deleteSupplier, params),
    getSupplierById: params => post(erpDataApiDic.getSupplierById, params),
    addSupplier: params => post(erpDataApiDic.addSupplier, params),
    updateSupplier: params => post(erpDataApiDic.addSupplier, params),

    getSupplierBanks: params => post(erpDataApiDic.getSupplierBanks, params),
    deleteSupplierBank: params => post(erpDataApiDic.deleteSupplierBank, params),
    updateSupplierBank: params => post(erpDataApiDic.updateSupplierBank, params),
    addSupplierBank: params => post(erpDataApiDic.addSupplierBank, params),

    getCustomerTypes: params => post(erpDataApiDic.getCustomerTypes, params),
    getCustomers: params => post(erpDataApiDic.getCustomers, params),
    deleteCustomer: params => post(erpDataApiDic.deleteCustomer, params),
    getCustomerById: params => post(erpDataApiDic.getCustomerById, params),
    addCustomer: params => post(erpDataApiDic.addCustomer, params),
    updateCustomer: params => post(erpDataApiDic.updateCustomer, params),

    getCustomerBanks: params => post(erpDataApiDic.getCustomerBanks, params),
    deleteCustomerBank: params => post(erpDataApiDic.deleteCustomerBank, params),
    updateCustomerBank: params => post(erpDataApiDic.updateCustomerBank, params),
    addCustomerBank: params => post(erpDataApiDic.addCustomerBank, params),

    getProductTags: params => post(erpDataApiDic.getProductTags, params),
    addProductTag: params => post(erpDataApiDic.addProductTag, params),
    updateProductTag: params => post(erpDataApiDic.updateProductTag, params),
    deleteProductTag: params => post(erpDataApiDic.deleteProductTag, params),

    getMessageCode: params => post(erpDataApiDic.getMessageCode, params),

    getRegisters: params => post(erpDataApiDic.getRegisters, params),
    auditRegister:params =>  post(erpDataApiDic.auditRegister, params),
    regist:params =>  post(erpDataApiDic.regist, params),

    getBorrowList: params => get(erpDataApiDic.getBorrowList, params),

    LeaseOrderList: params => post(erpDataApiDic.LeaseOrderList, params),

    leaseMachineList: params => post(erpDataApiDic.leaseMachineList, params),

    GetDictionaryCounterTypeList: params => post(erpDataApiDic.GetDictionaryCounterTypeList, params),

    

    LeaseOrderDetailById: params => post(erpDataApiDic.LeaseOrderDetailById, params),

    // GetDictionaryCounterTypeList: params => post(erpDataApiDic.GetDictionaryCounterTypeList, params),

    


    sequenceCodeUpdateForMore: params => post(erpDataApiDic.sequenceCodeUpdateForMore, params),

    updateSequenceCodeAddress: params => post(erpDataApiDic.updateSequenceCodeAddress, params),

    

    GetDetailByLeaseId: params => post(erpDataApiDic.GetDetailByLeaseId, params),

    GetMeterReadingByMachine: params => post(erpDataApiDic.GetMeterReadingByMachine, params),


    

    GetAcceptListAndMaintain: params => post(erpDataApiDic.GetAcceptListAndMaintain, params),
    GetCounterBySequenceCodeId: params => post(erpDataApiDic.GetCounterBySequenceCodeId, params),


    
    


    sequenceCodeUpdateForCounter: params => post(erpDataApiDic.sequenceCodeUpdateForCounter, params),
    counterAddForMore: params => post(erpDataApiDic.counterAddForMore, params),

    
    
    
    settlementMeterReadingAddForPC: params => post(erpDataApiDic.settlementMeterReadingAddForPC, params),

    LeaseOrderSettlement: params => post(erpDataApiDic.LeaseOrderSettlement, params),
    financialLeaseSettlementAddForPC: params => post(erpDataApiDic.financialLeaseSettlementAddForPC, params),
    // 获取税率
    getTaxRate: params => get(erpDataApiDic.getTaxRate, params),
    


    getWaitBorrowList: params => post(erpDataApiDic.getWaitBorrowListx, params),
    getOKistSecend: params => post(erpDataApiDic.getWaitBorrowListSecend, params),

    getFinacial: params => post(erpDataApiDic.getFinacialx, params),
    updateTickets: params => post(erpDataApiDic.invoiceInfoUpdateX, params),
    invoiceInfoAdd: params => post(erpDataApiDic.invoiceInfoAdd, params),
    getInvoiceInfoList: params => post(erpDataApiDic.getInvoiceInfoListX, params),
    getExpressAddressList: params => post(erpDataApiDic.getExpressAddressListX, params),
    expressAddressDelete: params => post(erpDataApiDic.expressAddressDeleteX, params),
    expressAddressAdd: params => post(erpDataApiDic.expressAddressAddX, params),

    CustomerBankAccountDelete: params => post(erpDataApiDic.CustomerBankAccountDelete, params),

    

    GetRoleWarehouseListByUserIdNew: params => post(erpDataApiDic.GetRoleWarehouseListByUserIdNew, params),
    GetRoleproductCategoryListByPutproductNew:params => post(erpDataApiDic.GetRoleproductCategoryListByPutproductNew, params),

    /** 设置审核 */
    //获取公司部门信息
    getDepartmentAndUserList: params => get(erpDataApiDic.GetDepartmentAndUserList,params),

    /** 修改密码/忘记密码 */
    updatePwd: params =>post(erpDataApiDic.updatePwd,params),

    /** 获取菜单目录 */
    getApplicationList: params =>post(erpDataApiDic.getApplicationList,params),
    /**修改菜单目录 */
    updateApplicationList: params =>post(erpDataApiDic.updateApplicationList,params),

    //新建库区
    reservoirAdd: params =>post(erpDataApiDic.reservoirAdd,params),
    // 编辑库区
    reservoirUpdate:params =>post(erpDataApiDic.reservoirUpdate,params,),
    ///获取已经新建过的最大库位编码
    getMaxStorehouseCode:params =>post(erpDataApiDic.getMaxStorehouseCode,params),
    //新建库位
    storehouseAdd:params =>post(erpDataApiDic.storehouseAdd,params),
    //get仓库类型
    getStoreType:params =>post(erpDataApiDic.getStoreType,params),
    //员工批量上传
    uploadUserExcel:params =>post(erpDataApiDic.uploadUserExcel,params),
};

export const erpWebApi = {
    getDictionaryUserOptions: params => get(erpWebApiDic.getDictionaryUserOptions, params),

    //商品维护 V2接口
    addProductV2: params =>post(erpWebApiDic.addProductV2, params),
    updateProductV2: params =>post(erpWebApiDic.updateProductV2, params),
    deleteProductV2: params =>postQuery(erpWebApiDic.deleteProductV2, params),
    getProductListV2:params =>post(erpWebApiDic.getProductListV2,params),
    getDetailV2:params => postQuery(erpWebApiDic.getDetailV2, params),
    getProductBrandsV2:params => post(erpWebApiDic.getProductBrandsV2, params),
    getProductCategoryV2:params =>post(erpWebApiDic.getProductCategoryV2, params),

    //客户维护 V2接口
    getCustomerListV2: params =>post(erpWebApiDic.getCustomerListV2,params),
    getCustomerDetailV2: params =>postQuery(erpWebApiDic.getCustomerDetailV2,params),
    addCustomerV2:params =>post(erpWebApiDic.addCustomerV2,params),
    editCustomerV2:params =>post(erpWebApiDic.editCustomerV2,params),
    deleteCustomerV2:params =>postQuery(erpWebApiDic.deleteCustomerV2,params),

    GetCode: params => postQuery(erpWebApiDic.GetCode, params), // 获取物料编码

    //供应商维护 V2接口
    getSupplierListV2:params =>post(erpWebApiDic.getSupplierListV2,params),
    getSupplierDetailV2:params =>postQuery(erpWebApiDic.getSupplierDetailV2,params),
    getSupplierStatusV2:params =>post(erpWebApiDic.getSupplierStatusV2,params),
    addSupplierV2:params =>post(erpWebApiDic.addSupplierV2,params),
    editSupplierV2:params =>post(erpWebApiDic.editSupplierV2,params),
    editBankAcoutInfoV2:params =>post(erpWebApiDic.editBankAcoutInfoV2,params),

    //仓库维护 V2接口
    addWarehouseV2:params => post(erpWebApiDic.addWarehouseV2,params),
    editWarehouseV2:params => post(erpWebApiDic.editWarehouseV2,params),
    getWarehouseCodeV2:params => post(erpWebApiDic.getWarehouseCodeV2,params),
    getWarehouseDetailV2:params => postQuery(erpWebApiDic.getWarehouseDetailV2,params),
    getStorageListV2:params =>get(erpWebApiDic.getStorageListV2,params),
    warehouseStartV2:params =>postQuery(erpWebApiDic.warehouseStartV2,params),
    warehouseStopV2:params =>postQuery(erpWebApiDic.warehouseStopV2,params),
    

    //以下是新仓库的接口，对应端口号8004
    uploadStorageProducts:params =>postNewStore(erpWebApiDic.uploadStorageProducts,params),
    getStorageProductListV2:params =>postNewStore(erpWebApiDic.getStorageProductListV2,params),

    //获取微信授权链接
    getWxCallback:params =>get(erpWebApiDic.getWxCallback,params),
    getAuthCode:params  =>get(erpWebApiDic.getAuthCode,params),
};


// WEBPACK FOOTER //
// ./src/utils/request.js